<template>
    <div class="card-data ranking">
        <Tooltip
            v-show="tip"
            :tip="tip" />
            
        <div class="card-title">
            <h5>{{title}}</h5>
        </div>
        <div v-if="!loader">
            <Loader/>
        </div>
        <!-- <EmptyStateChart v-else-if="data.length==0"
        :title="titleEmpty"
        :caption="captionEmpty"
        /> -->
        <div class="ranking-table" v-else>
            <div class="table-row head">
                <p class="name">Nombre</p>
                <p class="number">Interacciones</p>
            </div>
            <div class="table-row" v-for="(item,key) in data" :key="key">
                <p class="name">{{item.name}}</p>
                <p class="number">{{item.clicks}}</p>
            </div>
        </div>
    </div>
</template>

<script>
import Loader from '@/components/Loader'
import Tooltip from '@/components/Tooltip'
import EmptyStateChart from '@/components/EmptyStateChart'

export default {
    name: 'RankingCard',
    components: {
        Loader,
        Tooltip,
        EmptyStateChart
    },
    props: {
        title: {
            type: String,
            required: true
        },
        data: {
            type: Array,
            required: true
        },
        loader: {
            type: Boolean,
            default: false
        },
        tip: {
            type: String,
            default: ""
        },
        captionEmpty:{
            type: String,
            default: "Puedes consultar la vista de los últimos 7 o 30 días.",
        },
        titleEmpty: {
            type: String,
            default: "Este gráfico no esta disponible para esta vista"
        }
    }
}
</script>

<style lang="sass">
.ranking 
    .card-title
.ranking-table
    grid-column-start: 2
    grid-column-end: 3
    font-family: $title-font
    font-size: 14px
    color: #302f2f
    margin-bottom: $sm
    text-align: left
    box-sizing: border-box
    margin-top: $sm
    min-width: 100%
    @include tablet-portrait
        width: 100%
    .table-row
        display: flex
        flex-direction: row
        flex-grow: 0
        flex-wrap: wrap
        width: 100%
        font-family: $body-font
        .name
            flex-grow: 1
            overflow: hidden
            white-space: nowrap
            text-overflow: ellipsis
            width: 50%
            @include tablet-landscape
                font-size: 12px
            @include tablet-portrait
                font-size: 12px
        .number
            flex-grow: 1
            text-align: right
            width: 50%
            @include tablet-landscape
                font-size: 12px
            @include tablet-portrait
                width: 40%
                font-size: 12px
        &.head
            font-family: $title-font
            margin-bottom: $xs
            font-weight: bold
            .number
                text-align: right
</style>